import React from 'react';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { useFormContext, useWatch } from 'react-hook-form';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { UploadFile, Preview } from '@mui/icons-material';
import { FinanceProgramFormValues } from 'modules/desking/types';

interface Props {}

export const EquipmentActions = ({}: Props) => {
  const { setValue } = useFormContext<FinanceProgramFormValues>();

  const assets = useWatch({ name: 'equipment.assets' }) as File[];

  const { handleOpen: handleOpenUploadEquipmentImagesDialog } = useModal(ModalsKeys.UploadImagesForNewEquipmentDialog);
  const { handleOpen: handleOpenPreviewEquipmentImagesDialog } = useModal(ModalsKeys.PreviewNewEquipmentImagesDialog);

  const onUploadImagesDialogSave = (files: File[]) => {
    setValue('equipment.assets', files);
  };

  const onPreviewImagesConfirm = (files: File[]) => {
    setValue('equipment.assets', files);
  };

  return (
    <>
      <Stack direction="row" gap="1rem">
        <Tooltip title="Upload Equipment Images">
          <IconButton
            color="primary"
            className="icon-btn-bordered"
            onClick={() => {
              handleOpenUploadEquipmentImagesDialog({ onSave: onUploadImagesDialogSave });
            }}
          >
            <UploadFile />
          </IconButton>
        </Tooltip>

        <Tooltip title="Preview Equipment Images">
          <IconButton
            disabled={!assets?.length}
            color="primary"
            className="icon-btn-bordered"
            onClick={() => {
              handleOpenPreviewEquipmentImagesDialog({ files: assets, onConfirm: onPreviewImagesConfirm });
            }}
          >
            <Preview />
          </IconButton>
        </Tooltip>
      </Stack>
    </>
  );
};
